import { render, staticRenderFns } from "./approver-list.vue?vue&type=template&id=039a9a27"
import script from "./approver-list.vue?vue&type=script&lang=js"
export * from "./approver-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports